export default __webpack_public_path__ + "static/media/other06.a74ff760.webp";